module.exports = __webpack_public_path__ + "4bee04077de7e8206090d31f1b7f1bd3.svg";